<template>
  <div class="page">
    <div class="page_contents">
      <div class="contents_div">
        <div class="page_header">
          <div class="page_header_circle"></div>
          공고상세
        </div>
        <table class="detail_table">
          <tbody>
            <tr>
              <td class="table_label">공고기관</td>
              <td class="font-bold">{{ announceData.공고기관 }}</td>
              <td class="table_label">공고번호</td>
              <td>{{ announceData.공고번호 }}</td>
            </tr>
            <tr>
              <td class="table_label">발주처</td>
              <td class="font-bold">{{announceData.발주처}}</td>
              <td class="table_label">수행상태</td>
              <td class="font-bold flex_td">
                {{ announceData.수행상태 }}
                <img v-if="announceData.진행여부" 
                  class="contact_add_btn" 
                  src="@/assets/images/contact_add_icon.png" 
                  @click="openStatusPop(announceData.수행상태 || '')" 
                />
              </td>
            </tr>
            <tr>
              <td class="table_label">공고명</td>
              <td colspan="3" class="font-bold">{{ announceData.공고명 }}</td>
            </tr>
            <tr>
              <td class="table_label">낙찰금액</td>
              <td>{{ numberFormat(announceData.낙찰금액) }}원</td>
              <td class="table_label">수행금액</td>
              <td>{{ numberFormat(announceData.수행금액) }}원</td>
            </tr>
            <!-- <tr>
              <td class="table_label">부가세</td>
              <td colspan="3">{{ calculateVAT(announceData.수행금액) }}원</td>
            </tr> -->
            <tr>
              <td class="table_label">마진금액</td>
              <td>{{ calculateMarginAmount(announceData.낙찰금액, announceData.수행금액) }} ({{ calculateMarginRate(announceData.낙찰금액, announceData.수행금액) }})</td>
              <td class="table_label">낙찰일</td>
              <td>{{ announceData.낙찰일 }}</td>
            </tr>
            <tr>
              <td class="table_label">수주업체</td>
              <td class="flex_td">
                {{ announceData.수주회원?.사업자명 }}
                <img title="사업자등록증 다운로드" src="@/assets/images/file_icon.png" v-if="announceData.수주회원.사업자등록증" style="cursor: pointer"
                    @click="getFile(announceData.공고순번, announceData.수주회원.사업자등록증.저장순번, announceData.수주회원.사업자등록증.원파일명)"
                />
              </td>
              <td class="table_label">수행업체</td>
              <td class="flex_td">
                {{ announceData.수행회원?.사업자명 }}
                <img title="사업자등록증 다운로드" src="@/assets/images/file_icon.png" v-if="announceData.수행회원.사업자등록증" style="cursor: pointer"
                    @click="getFile(announceData.공고순번, announceData.수행회원.사업자등록증.저장순번, announceData.수행회원.사업자등록증.원파일명)"
                />
              </td>
            </tr>
            <tr>
              <td class="table_label">착수일</td>
              <td>{{ announceData.착수일 }}</td>
              <td class="table_label">계약기간</td>
              <td>{{ announceData.계약시작일 }} ~ {{ announceData.계약종료일 }}</td>
            </tr>
            <tr>
              <td class="table_label">공고 링크</td>
              <td>
                <a style="color: blue; text-decoration: underline" :href="announceData.원공고링크" target="_blank">공고 보러 가기</a>
              </td>
              <td class="table_label">계약서</td>
              <td style="display: flex;align-items: center;">
                <div style="display: flex;flex-direction: column;justify-content: center;">
                  <div style="color: blue; text-decoration: underline;cursor: pointer;" 
                    @click="getFile(announceData.공고순번, announceData.계약서?.저장파일?.저장순번, announceData.계약서?.저장파일?.원파일명)"
                  >{{ announceData.계약서?.저장파일?.원파일명 }}</div>
                  <div>{{ store.userInfo.회원순번 == announceData.수행회원.회원순번 ? announceData.계약서?.수주계약서작성여부 ? 
                    '':'수주업체 계약서 작성 전' : announceData.계약서?.수행계약서작성여부 ? '':'수행업체 계약서 작성 전'}}</div>
                </div>
                <div style="margin-left: auto;background: #3382e9;padding: 5px 10px;color: #fff;font-weight: 500;cursor: pointer;" @click="openContactPopList">계약이력</div>
              </td>
            </tr>
            <tr>
              <td class="table_label">비고</td>
              <td colspan="3">
                <div
                    style="height: 100px; overflow-y: auto; width: 100%"
                    v-html="announceData.비고.replace(/\n/g, '<br>')"
                  ></div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="contact_wrap">
          <div class="contact_outer_div">
            <div class="contact_title">대금지급 정보</div>
            <div class="pay_info_wrap">
              <!-- 발주처 대금지급정보 -->
              <div class="order_box">
                <div style="border-right: 2px solid #dbdbdb" class="box_title">
                  발주처 대금지급정보
                  <img v-if="announceData.진행여부 && store.userInfo.회원순번 == announceData.수주회원.회원순번" 
                    class="contact_add_btn pay_mod_btn" 
                    src="@/assets/images/contact_add_icon.png" 
                    @click="openPaymentInfoPop('발주처')" 
                  />
                </div>
                <!-- 발주처 정보 렌더링 -->
                <div v-for="(info, index) in announceData.공고대금지급정보.filter((item) => item.발주처수주구분 === '발주처')" :key="`발주처-${index}`" style="border-right: 2px solid #dbdbdb" class="box_inp_wrap">
                  <div style="border-right: 1px solid #dbdbdb" class="flex_wrap">
                    <div class="pay_gubun">{{ info.지급구분 }}</div>
                  </div>
                  <div style="border-right: 1px solid #dbdbdb" class="flex_wrap">
                    <div class="pay_date">{{ info.지급일자 }}</div>
                  </div>
                  <div class="flex_wrap">
                    <div class="pay_rate">{{ info.지급율 }}</div>
                    <div>%</div>
                  </div>
                  <div style="border-left: 1px solid #dbdbdb" class="flex_wrap">
                    <div class="pay_amt">{{ formatCurrency(info.지급금액) }}</div>
                    <div>원</div>
                  </div>
                </div>
                <div v-if="announceData.공고대금지급정보.length == 0" style="border-right: 2px solid #dbdbdb; justify-content: center; min-height: 59px" class="box_inp_wrap">
                  <div style="font-family: 'Noto Sans CJK KR-Regular'; font-size: 12px" class="pay_amt">데이터가 없습니다.</div>
                </div>
              </div>

              <!-- 수주/수행 대금지급정보 -->
              <div class="receive_execution_box">
                <div class="box_title">
                  수주/수행 대금지급정보
                  <img v-if="announceData.진행여부 && store.userInfo.회원순번 == announceData.수주회원.회원순번" 
                    class="contact_add_btn pay_mod_btn" 
                    src="@/assets/images/contact_add_icon.png" 
                    @click="openPaymentInfoPop('수주')" 
                  />
                </div>
                <!-- 수주 정보 렌더링 -->
                <div v-for="(info, index) in announceData.공고대금지급정보.filter((item) => item.발주처수주구분 === '수주')" :key="`수주-${index}`" class="box_inp_wrap">
                  <div style="border-right: 1px solid #dbdbdb" class="flex_wrap">
                    <div class="pay_gubun">{{ info.지급구분 }}</div>
                  </div>
                  <div style="border-right: 1px solid #dbdbdb" class="flex_wrap">
                    <div class="pay_date">{{ info.지급일자 }}</div>
                  </div>
                  <div style="border-right: 1px solid #dbdbdb" class="flex_wrap">
                    <div class="pay_rate">{{ info.지급율 }}</div>
                    <div>%</div>
                  </div>
                  <div style="border-right: 1px solid #dbdbdb;padding-right: 10px;" class="flex_wrap">
                    <div class="pay_amt">{{ formatCurrency(info.지급금액) }}</div>
                    <div>원</div>
                  </div>
                  <div class="flex_wrap" v-if="announceData.진행여부 && store.userInfo.회원순번 == announceData.수행회원.회원순번" >
                    <div v-if="!info.수행회원금액확인" style="background: #383838;color:#fff;padding: 5px 10px;cursor: pointer;" @click="paymentCheck(info)">
                      금액 확인
                    </div>
                    <div v-if="info.수행회원금액확인 && !info.수행회원입금확인" style="background: #383838;color:#fff;padding: 5px 10px;cursor: pointer;" @click="paymentConfirm(info)">
                      입금 확인
                    </div>
                    <div v-if="info.수행회원금액확인 && info.수행회원입금확인" style="color:#3382e9;padding: 5px 10px;">
                      입금 확인 완료
                    </div>
                  </div>
                  <div class="flex_wrap" v-if="store.userInfo.회원순번 === announceData.수주회원.회원순번 || !announceData.진행여부">
                    <div style="color:#000;padding: 5px 10px;" v-if="!info.수행회원금액확인"
                      :style="{color: info.수행회원금액확인 ? '#3382e9' : '#000'}"
                    >
                      금액 확인 {{info.수행회원금액확인 ? '완료' : '대기'}}
                    </div>
                    <div style="color:#000;padding: 5px 10px;" v-if="info.수행회원금액확인"
                      :style="{color: info.수행회원입금확인 ? '#3382e9' : '#000'}"
                    >
                      입금 확인 {{info.수행회원입금확인 ? '완료' : '대기'}}
                    </div>
                  </div>
                </div>
                <div v-if="announceData.공고대금지급정보.length == 0" style="justify-content: center; min-height: 59px" class="box_inp_wrap">
                  <div style="font-family: 'Noto Sans CJK KR-Regular'; font-size: 12px" class="pay_amt">데이터가 없습니다.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="contact_outer_div">
            <div class="contact_title">수주담당자 연락처</div>
            <div class="contact_div">
              <div class="contact_header">
                <div class="contact_label">성함</div>
                <div class="contact_label">연락처</div>
                <div class="contact_label">직통번호</div>
                <div class="contact_label">이메일</div>
                <div class="contact_label">비고</div>
                <img v-if="store.userInfo.회원순번 == announceData.수주회원.회원순번 && announceData.진행여부" 
                  class="contact_add_btn" 
                  src="@/assets/images/contact_add_icon.png" 
                  @click="openContactPop('수주')" 
                />
              </div>
              <ul class="contact_ul">
                <li class="contact_li">
                  <div class="contact_nm">{{ announceData.수주담당자이름1 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자전화번호1 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자직통번호1 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자이메일1 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자비고1 }}</div>
                </li>
                <li class="contact_li">
                  <div class="contact_nm">{{ announceData.수주담당자이름2 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자전화번호2 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자직통번호2 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자이메일2 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자비고2 }}</div>
                </li>
                <li class="contact_li">
                  <div class="contact_nm">{{ announceData.수주담당자이름3 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자전화번호3 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자직통번호3 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자이메일3 }}</div>
                  <div class="contact_tel">{{ announceData.수주담당자비고3 }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="contact_outer_div">
            <div class="contact_title">수행담당자 연락처</div>
            <div class="contact_div">
              <div class="contact_header">
                <div class="contact_label">성함</div>
                <div class="contact_label">연락처</div>
                <div class="contact_label">직통번호</div>
                <div class="contact_label">이메일</div>
                <div class="contact_label">비고</div>
                <img v-if="store.userInfo.회원순번 == announceData.수행회원.회원순번 && announceData.진행여부" 
                  class="contact_add_btn" 
                  src="@/assets/images/contact_add_icon.png" 
                  @click="openContactPop('수행')" 
                />
              </div>
              <ul class="contact_ul">
                <li class="contact_li">
                  <div class="contact_nm">{{ announceData.수행담당자이름1 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자전화번호1 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자직통번호1 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자이메일1 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자비고1 }}</div>
                </li>
                <li class="contact_li">
                  <div class="contact_nm">{{ announceData.수행담당자이름2 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자전화번호2 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자직통번호2 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자이메일2 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자비고2 }}</div>
                </li>
                <li class="contact_li">
                  <div class="contact_nm">{{ announceData.수행담당자이름3 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자전화번호3 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자직통번호3 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자이메일3 }}</div>
                  <div class="contact_tel">{{ announceData.수행담당자비고3 }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="page_header">
          <div class="page_header_circle"></div>
          수주업체 첨부파일
          <div class="all_download_btn" style="margin-left:auto;" @click="getFiles('수주')">전체 다운로드</div>
        </div>

        <ul class="file_ul">
          <li class="file_li" v-for="첨부파일 in announceData.수주첨부파일들" v-bind:key="첨부파일.공고첨부파일순번">
            <div class="file_gubn">{{ 구분목록.filter((dto:any) => dto.코드 == 첨부파일.파일제목)[0].코드명 }}</div>
            <div class="file_name_div">
              <img src="@/assets/images/file_icon.png" />
              <div class="file_name" @click="getFile(announceData.공고순번, 첨부파일.저장순번, 첨부파일.원파일명)">{{ 첨부파일.원파일명 }}</div>
              <!-- <div class="file_name" @click="getFile(announceData.공고순번, 첨부파일.공고첨부파일순번, 첨부파일.첨부파일명)">{{ 첨부파일.원파일명 }}</div> -->
            </div>
            <!-- </div> -->
            <div class="file_btn_group">
              <!-- <div class="modify_btn">재등록</div> -->
              <div v-if="첨부파일.원파일명 != null && store.userInfo.회원순번 == announceData.수주회원.회원순번 && announceData.진행여부" 
                class="delete_btn" @click="deleteFile(첨부파일)">삭제</div>
              <div v-if="첨부파일.원파일명 == null && store.userInfo.회원순번 == announceData.수주회원.회원순번 && announceData.진행여부"
                class="delete_btn" @click="openFileUploadPop('수주', 첨부파일.요청순번, 첨부파일.파일제목 || null)">업로드</div>
            </div>
          </li>
          <li class="file_li" v-if="announceData.수주첨부파일들.length === 0">
            <div style="margin: 0 auto;">등록된 파일이 없습니다.</div>
          </li>
          <div class="file_li_wrap" v-if="announceData.진행여부">
            <li v-if="store.userInfo.회원순번 == announceData.수행회원.회원순번" class="file_li add" @click="openFileRequestPop('수주')">
              <img src="@/assets/images/file_icon.png" />
              파일 요청 +
            </li>
            <li v-if="store.userInfo.회원순번 != announceData.수행회원.회원순번" class="file_li add" @click="openFileUploadPop('수주')">
              <img src="@/assets/images/file_icon.png" />
              파일 첨부 +
            </li>
          </div>
        </ul>

        <div class="page_header">
          <div class="page_header_circle"></div>
          수행업체 첨부파일
          <div class="consent_btn" @click="toggleSealConsentPop = true" style="margin-left: auto;" 
            v-if="!announceData.사용인감사용여부 && store.userInfo.회원순번 == announceData.수주회원.회원순번">사용인감 동의서 작성</div>
          <div class="all_download_btn" :style="{marginLeft: announceData.사용인감사용여부 || store.userInfo.회원순번 == announceData.수행회원.회원순번 ? 'auto':'none'}" @click="getFiles('수행')">전체 다운로드</div>
        </div>

        <ul class="file_ul">
          <li class="file_li" v-for="첨부파일 in announceData.수행첨부파일들" v-bind:key="첨부파일.공고첨부파일순번">
            <div class="file_gubn">{{ 구분목록.filter((dto:any) => dto.코드 == 첨부파일.파일제목)[0].코드명 }}</div>
            <div class="file_name_div">
              <img src="@/assets/images/file_icon.png" />
              <div class="file_name" @click="getFile(announceData.공고순번, 첨부파일.저장순번, 첨부파일.원파일명)">{{ 첨부파일.원파일명 }}</div>
            </div>
            <div class="file_btn_group">
              <!-- <div class="modify_btn">재등록</div> -->
              <div v-if="!첨부파일.요청순번">
              <div v-if="첨부파일.원파일명.indexOf('.pdf') != -1 && store.userInfo.회원순번 == announceData.수행회원.회원순번 && announceData.진행여부 && announceData.사용인감사용여부" 
                class="delete_btn" @click="pdfCall(첨부파일)">날인</div>
              </div>
              <div v-if="첨부파일.원파일명 != null && store.userInfo.회원순번 == announceData.수행회원.회원순번 && announceData.진행여부" 
                class="delete_btn" @click="deleteFile(첨부파일)">삭제</div>
              <div v-if="첨부파일.원파일명 == null && store.userInfo.회원순번 == announceData.수행회원.회원순번 && announceData.진행여부"
                class="delete_btn" @click="openFileUploadPop('수행', 첨부파일.요청순번, 첨부파일.파일제목 || null)">업로드</div>
            </div>
          </li>
          <li class="file_li" v-if="announceData.수행첨부파일들.length === 0">
            <div style="margin: 0 auto;">등록된 파일이 없습니다.</div>
          </li>
          <div class="file_li_wrap" v-if="announceData.진행여부">
            <li v-if="store.userInfo.회원순번 == announceData.수주회원.회원순번" class="file_li add" @click="openFileRequestPop('수행')">
              <img src="@/assets/images/file_icon.png" />
              파일 요청 +
            </li>
            <li v-if="store.userInfo.회원순번 != announceData.수주회원.회원순번" class="file_li add" @click="openFileUploadPop('수행')">
              <img src="@/assets/images/file_icon.png" />
              파일 첨부 +
            </li>
          </div>
        </ul>
      </div>
    </div>
    <div class="note_icon_box">
      <div class="count_box" v-if="announceData.메모신규건수 != 0">{{ announceData.메모신규건수 }}</div>
      <img src="../assets/icon/note_icon.svg" alt="" @click="openNotePop" />
      <div class="note_text">공고 메모</div>
    </div>
  </div>
  <FileUploadPop :요청파일정보="요청파일정보" :공고순번="공고순번" :수주수행구분="수주수행구분" @closePopup="closePopup" v-if="toggleFileUploadPop"></FileUploadPop>
  <FileRequestPop :공고순번="공고순번" :수주수행구분="수주수행구분" @closePopup="closePopup" v-if="toggleFileRequestPop"></FileRequestPop>
  <ContactPop :announceData="announceData" :수주수행구분="수주수행구분" v-if="toggleContactPop" @closePopup="closePopup"></ContactPop>
  <PaymentInfoPop v-if="togglePaymentInfoPop" :announceData="announceData" :발주처수주구분="발주처수주구분" @getDetail="getDetail" @closePaymentInfoPopup="closePaymentInfoPopup"></PaymentInfoPop>
  <StatusPop v-if="toggleStatusPop" :status="currentStatus" @closePopup="closePopup"></StatusPop>
  <NotePop :announceData="announceData" @getDetail="getDetail" v-if="toggleNotePop" @closeNotepop="closeNotepop" />
  <PDFSealPop v-if="togglePDFPop" @closePDFpop="closePDFpop" :data="selectedFile!" :title="selectedTitle!" :공고순번="공고순번!"></PDFSealPop>
  <SealConsentPop v-if="toggleSealConsentPop" @closePopup="closePopup" :사업자명="announceData.수행회원.사업자명"></SealConsentPop>
  <ContractListPop v-if="toggleContactListPop" @closePopup="closePopup" @openContractPop="openContractPop" :공고순번="공고순번!" :회원구분="회원구분"></ContractListPop>
  <ContractPop v-if="contractFlag" :data="contract!" @close="contractClose"  :seq="공고순번!" :seq2="seq2!" :type="contractType"></ContractPop>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import FileUploadPop from "@/components/popup/FileUploadPop.vue";
import FileRequestPop from "@/components/popup/FileRequestPop.vue";
import ContactPop from "@/components/popup/ContactPop.vue";
import PaymentInfoPop from "@/components/popup/PaymentInfoPop.vue";
import NotePop from "@/components/popup/NotePop.vue";
import StatusPop from "@/components/popup/StatusPop.vue";
import PDFSealPop from "@/components/popup/PDFSealPop.vue";
import SealConsentPop from "@/components/popup/SealConsentPop.vue";
import ContractListPop from "@/components/popup/ContractListPop.vue";
import ContractPop from "@/components/popup/ContractPop.vue";
import announceAPI from "@/api/announceAPI";
import { Announce, ApiResponse, AnnounceFile, ClosePopupOptions, Member, PaymentInfo, Contract } from "../common/types";
import { numberFormat } from "@/utils/utils";
import { userStore } from "@/store/userStore";
import codeAPI from "@/api/codeAPI";
const announceData = ref<Announce>({
  공고순번: 0,
  공고번호: "",
  공고기관: "",
  발주처: "",
  공고명: "",
  낙찰금액: 0,
  수행금액: 0,
  수행상태: "",
  노출여부: "",
  진행여부: "",
  수주수행구분: "",
  수주회원: {} as Member, // Member 타입에 맞게 설정
  수행회원: {} as Member, // Member 타입에 맞게 설정
  낙찰일: "",
  착수일: "",
  계약시작일: "",
  계약종료일: "",
  선금여부: "",
  수주담당자이름1: "",
  수주담당자이름2: "",
  수주담당자이름3: "",
  수주담당자전화번호1: "",
  수주담당자전화번호2: "",
  수주담당자전화번호3: "",
  수주담당자직통번호1: "",
  수주담당자직통번호2: "",
  수주담당자직통번호3: "",
  수주담당자이메일1: "",
  수주담당자이메일2: "",
  수주담당자이메일3: "",
  수주담당자비고1: "",
  수주담당자비고2: "",
  수주담당자비고3: "",
  수행담당자이름1: "",
  수행담당자이름2: "",
  수행담당자이름3: "",
  수행담당자전화번호1: "",
  수행담당자전화번호2: "",
  수행담당자전화번호3: "",
  수행담당자직통번호1: "",
  수행담당자직통번호2: "",
  수행담당자직통번호3: "",
  수행담당자이메일1: "",
  수행담당자이메일2: "",
  수행담당자이메일3: "",
  수행담당자비고1: "",
  수행담당자비고2: "",
  수행담당자비고3: "",
  원공고링크: "",
  비고: "",
  등록자: "",
  등록일시: "",
  수정자: "",
  수정일시: "",
  수주첨부파일들: [],
  수행첨부파일들: [],
  수주계약서작성여부: true,
  수행계약서작성여부: true,
  공고대금지급정보: [] as PaymentInfo[],
  메모신규건수: 0,
  계약서: {} as Contract,
  사용인감사용여부: false,
});
const router = useRouter();
const formatCurrency = (value: number): string => {
  return value.toLocaleString();
};
const 공고순번 = ref<number | null>(null);
const 요청파일정보 = ref<{ 요청순번: number | null; 파일제목: string | null }>({
  요청순번: null,
  파일제목: null,
});
const 수주수행구분 = ref<string | null>(null);
const 발주처수주구분 = ref<string | null>(null);
const toggleFileUploadPop = ref(false);
const toggleFileRequestPop = ref(false);
const toggleContactPop = ref(false);
const togglePaymentInfoPop = ref(false);
const toggleStatusPop = ref(false);
const togglePDFPop = ref(false);
const toggleSealConsentPop = ref(false);
const toggleContactListPop = ref(false);
const contractFlag = ref(false);
const store = userStore();
const 구분목록: any = ref([]);
onMounted(() => {
  codeAPI.getSelectedCode('0002').then((res) => {
    구분목록.value = res.data.data
  });
  공고순번.value = Number(router.currentRoute.value.params.seq);
  getDetail();
});

const getDetail = () => {
  const seq = Number(router.currentRoute.value.params.seq);
  announceAPI.announceDetail(seq).then((res) => {
    const detailData = res.data.data;
    const 선금여부 = detailData.선금여부 ? "유" : "무";

    const formatPhoneNumber = (phone: string): string => {
      if (!phone) return ""; // 번호가 없으면 빈 문자열 반환
      return phone.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
    };

    // announceData 업데이트 (수주/수행 파일 분리 포함)
    announceData.value = {
      ...detailData,
      선금여부,
      수주첨부파일들: detailData.첨부파일목록.filter((file: any) => file.자료식별값2 == "수주"),
      수행첨부파일들: detailData.첨부파일목록.filter((file: any) => file.자료식별값2 == "수행"),
      수주담당자전화번호1: formatPhoneNumber(detailData.수주담당자전화번호1),
      수주담당자전화번호2: formatPhoneNumber(detailData.수주담당자전화번호2),
      수주담당자전화번호3: formatPhoneNumber(detailData.수주담당자전화번호3),
      수행담당자전화번호1: formatPhoneNumber(detailData.수행담당자전화번호1),
      수행담당자전화번호2: formatPhoneNumber(detailData.수행담당자전화번호2),
      수행담당자전화번호3: formatPhoneNumber(detailData.수행담당자전화번호3),
    };
  });
};

const openFileUploadPop = (type: string, reqNumber?: number | null, fileTitle?: string | null) => {
  수주수행구분.value = type;
  요청파일정보.value = {
    요청순번: reqNumber ?? null,
    파일제목: fileTitle ?? null,
  };

  toggleFileUploadPop.value = true;
};
const 회원구분 = ref<string>("")
const openContactPopList = () => {
  if(store.userInfo.회원순번 == announceData.value.수주회원.회원순번) {
    회원구분.value = "수주"
  } else if(store.userInfo.회원순번 == announceData.value.수행회원.회원순번) {
    회원구분.value = "수행"
  } else {
    alert("수주/수행 업체의 계약이력을 확인할 수 없습니다.")
    return
  }
  toggleContactListPop.value = true;
};
const openContactPop = (type: string) => {
  수주수행구분.value = type;
  toggleContactPop.value = true;
};
const openPaymentInfoPop = (type: string) => {
  발주처수주구분.value = type;
  togglePaymentInfoPop.value = true;
};
const openFileRequestPop = (type: string) => {
  수주수행구분.value = type;
  toggleFileRequestPop.value = true;
};
const contractClose = () => {
  contractFlag.value = false;
};
const seq2 = ref<number | null>(null);
const contract = ref<Contract | null>(null);
const contractType = ref("R")
const openContractPop = (data: Contract) => {
  seq2.value = data.저장파일!.저장순번!;
  contract.value = data;
  if(data[`${회원구분.value}계약서작성여부`]) {
    contractType.value = "R"
  } else {
    contractType.value = "U"
  }
  contractFlag.value = true;
};
const paymentCheck = (info: PaymentInfo) => {
  if (confirm("지급금액을 확인하셨습니까?")) {
    
    announceAPI.savePayment(announceData.value.공고순번, {
      공고대금지급정보등록: [],
      공고대금지급정보수정: [{지급순번:info.지급순번,수행회원금액확인: true}],
      공고대금지급정보삭제: [],
    }).then(() => {
      getDetail()
    });
  }
};
const paymentConfirm = (info: PaymentInfo) => {
  if (confirm("입금을 확인하셨습니까?")) {
    announceAPI.savePayment(announceData.value.공고순번, {
      공고대금지급정보등록: [],
      공고대금지급정보수정: [{지급순번:info.지급순번,수행회원입금확인: true}],
      공고대금지급정보삭제: [],
    }).then(() => {
      getDetail()
    });
  }
};
const closePopup = ({ popupType, refresh, selectedData }: ClosePopupOptions) => {
  if (popupType === "fileUpload") toggleFileUploadPop.value = false;
  else if (popupType === "contact") toggleContactPop.value = false;
  else if (popupType === "contractList") toggleContactListPop.value = false;
  else if (popupType === "status") {
    toggleStatusPop.value = false;
    if (selectedData) {
      announceData.value = { ...announceData.value, 수행상태: selectedData };
    }
    if(currentStatus.value !== selectedData && refresh) {
      announceAPI.modifyContact({ 수행상태: selectedData },공고순번.value!).then((res) => {
        if (res.data.success) {
          alert("수행상태가 변경되었습니다.");
        } else {
          alert("수행상태 변경에 실패했습니다.");
        }
      });
    } else {
      announceData.value.수행상태 = currentStatus.value!
    }
    // 수행상태 변경 팝업에서는 새로고침하지 않음
    return;
  } else if (popupType === "fileRequest") toggleFileRequestPop.value = false;
  else if(popupType === "consent") {
    toggleSealConsentPop.value = false;
    if(!selectedData) return
    announceAPI.modifyContact({ 사용인감사용여부: selectedData },공고순번.value!).then((res) => {
      if (res.data.success) {
        alert("사용인감 사용에대해 동의하셨습니다.");
        announceData.value.사용인감사용여부 = selectedData as unknown as boolean;
      }
    });
  }
  if (refresh) {
    getDetail();
  }
};

const closePaymentInfoPopup = () => {
  togglePaymentInfoPop.value = false;
};
const selectedFile = ref<AnnounceFile | null>();
const selectedTitle = ref<string | null>(null);
const pdfCall = (첨부파일: AnnounceFile) => {
  selectedFile.value = 첨부파일;
  selectedTitle.value = 구분목록.value.filter((dto:any) => dto.코드 == 첨부파일.파일제목)[0].코드명
  togglePDFPop.value = true;
}
const deleteFile = (첨부파일: AnnounceFile) => {
  if (confirm("첨부파일을 삭제 하시겠습니까?")) {
    const 공고순번 = announceData.value.공고순번;
    const 저장순번 = 첨부파일.저장순번; // 첨부파일 객체에서 저장순번을 가져옴

    if (!공고순번 || !저장순번) {
      alert("파일 삭제에 필요한 정보가 누락되었습니다.");
      return;
    }

    announceAPI
      .deleteAnnounceFile(공고순번, 저장순번)
      .then((res: ApiResponse) => {
        if (res.success) {
          alert("삭제가 완료되었습니다.");
          getDetail(); // 삭제 후 목록 갱신
        } else {
          alert("첨부파일 삭제에 실패했습니다.");
        }
      })
      .catch((error) => {
        alert("첨부파일 삭제 중 오류가 발생했습니다.");
      });
  }
};

const getFile = (공고순번: number, 저장순번: number | undefined, 파일명: string) => {
  if (저장순번 === undefined || 저장순번 === null) {
    alert("파일 정보를 불러올 수 없습니다. 다시 시도해주세요.");
    return;
  }

  announceAPI.downloadAnnounceFile(공고순번, 저장순번, 파일명);
};
const getFiles = (수주수행구분:string) => {
  announceAPI.downloadAllAnnounceFile(announceData.value, 수주수행구분);
}
// 수행상태 변경 팝업 open
const currentStatus = ref<string | null>(null);
const openStatusPop = (status: string) => {
  currentStatus.value = status;
  toggleStatusPop.value = true;
};
const calculateMarginRate = (bidAmount: number, performanceAmount: number): string => {
  if (bidAmount === 0) return "0%";
  const marginRate = ((bidAmount - performanceAmount) / bidAmount) * 100;
  return `${marginRate.toFixed(2)}%`;
};
// const calculateVAT = (수행금액: number): string => {
//   const 부가세 = 수행금액 * 0.1; // 부가세 계산

//   // 세 자리마다 콤마 추가
//   return 부가세.toLocaleString("ko-KR");
// };
const calculateMarginAmount = (bidAmount: number, performanceAmount: number): string => {
  const marginAmount = bidAmount - performanceAmount;
  return `${numberFormat(marginAmount)}원`;
};
// NotePop 표시 여부를 관리하는 상태 변수
const toggleNotePop = ref<boolean>(false); // ref의 타입을 boolean으로 명시

// NotePop을 여는 함수
const openNotePop = (): void => {
  toggleNotePop.value = true;
};

// NotePop을 닫는 함수
const closeNotepop = (): void => {
  toggleNotePop.value = false;
};
const closePDFpop = () => {
  togglePDFPop.value = false;
  selectedFile.value = null;
}
</script>
<style scoped>
.page_header {
  /* border-bottom: 1px solid #e0e0e0; */
  padding: 40px 0px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 22px;
  display: flex;
  gap: 16px;
  align-items: center;
  line-height: 35px;
}
.page_header_circle {
  width: 18px;
  height: 18px;
  border-radius: 18px;
  border: 5px solid #e5e8ec;
}

.page_contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 100px;
  align-items: center;
}

.contents_div {
  width: 1010px;
}
.detail_table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  border-top: 3px solid #041e42;
  margin-bottom: 30px;
}

.detail_table td {
  border-bottom: 1px solid #dbdbdb;
  height: 43px;
  padding-left: 20px;
  color: #272727;
}
.table_label {
  background-color: #f6f7fb;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  width: 150px;
}

.font-bold {
  font-family: "Noto Sans CJK KR-Bold";
  width: 355px;
}

.file_ul {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.file_li {
  display: flex;
  flex-direction: row;
  border: 2px solid #383838;
  height: 71px;
  align-items: center;
  padding: 19px 20px 19px 50px;
  border-radius: 9px;
  background: #f6f7fb;
}
.file_gubn {
  min-width: 140px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 16px;
  letter-spacing: -0.02em;
}
.file_name_div {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.file_name {
  color: #0078db;
  text-decoration: underline;
  cursor: pointer;
}
.file_btn_group {
  gap: 10px;
  display: flex;
}
.modify_btn {
  width: 104px;
  height: 33px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #041e42;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  cursor: pointer;
}
.delete_btn {
  width: 104px;
  height: 33px;
  background: #383838;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #041e42;
  color: white;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  cursor: pointer;
}
.download_btn {
  margin-left:auto;
  width: 150px;
  height: 33px;
  background: #383838;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #041e42;
  color: white;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  cursor: pointer;
}
.all_download_btn {
  width: 150px;
  height: 33px;
  background: #383838;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #041e42;
  color: white;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  cursor: pointer;
}
.consent_btn {
  width: 150px;
  height: 33px;
  background: #383838;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #041e42;
  color: white;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  cursor: pointer;
}
.file_li.add {
  justify-content: center;
  gap: 13px;
  border: 1.5px dotted #bcbcbc;
  background: white;
  color: #181818;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 18px;
  cursor: pointer;
  width: 100%;
}
/* 연락처 관련  */
.contact_wrap {
  display: flex;
  gap: 20px;
  flex-direction: column;
}
.contact_outer_div {
  width: 100%;
}
.contact_title {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 16px;
  margin-bottom: 10px;
}
.contact_div {
  border: 2px solid #dbdbdb;
  padding: 20px 30px;
  border-radius: 9px;
}
.contact_header {
  display: flex;
  align-items: center;
}
.contact_label {
  font-size: 14px;
  color: #b9b9b9;
  font-family: "Noto Sans CJK KR-Bold";
  line-height: 19px;
}
.contact_label {
  width: calc((100% - 15px) / 5);
}
/* .contact_label:nth-child(1) {
  min-width: 141px;
}
.contact_label:nth-child(2) {
  width: 141px;
}
.contact_label:nth-child(3) {
  width: 141px;
}
.contact_label:nth-child(4) {
  width: 141px;
}
.contact_label:nth-child(5) {
  width: 141px;
} */
.contact_li {
  display: flex;
  height: 39px;
  border-bottom: 1px solid #dbdbdb;
  align-items: center;
}
.contact_li:nth-last-child(1) {
  border-bottom: none;
}
.contact_nm,
.contact_tel {
  width: calc((100% - 15px) / 5);
  color: #041e42;
  line-height: 19px;
  font-size: 14px;
}
/* .contact_nm {
  min-width: 141px;
} */

/* .contact_tel {
  width: 141px;
} */
.contact_add_btn {
  cursor: pointer;
}
/* 공고상세 table td중 flex를 사용해야하는 경우 class명 */
.flex_td {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}
.note_icon_box {
  position: absolute;
  top: 759px;
  right: 144px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 88px;
  height: 88px;
}
.count_box {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ff5a5a;
  background-color: #ff5a5a;
  color: #ffff;
  border-radius: 14px;
  width: 28px;
  height: 28px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Bold";
  right: -3px;
  top: 0px;
}
.note_text {
  font-size: 14px;
  text-align: center;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -1.2px;
}
.file_li_wrap {
  display: flex;
  gap: 5px;
}
.order_client {
  background-color: #f6f7fb;
  border-right: 1px solid #dbdbdb;
  font-family: "Noto Sans CJK KR-Bold";
  width: 150px;
  font-size: 14px;
  text-align: center;
}
.receive_execution {
  background-color: #f6f7fb;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  text-align: center;
}
.pay_info_wrap {
  display: flex;
  border: 2px solid #dbdbdb;
  border-radius: 6px;
}
.pay_info_wrap > div {
  width: 50%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.order_box {
  width: 100%;
}
.receive_execution_box {
  width: 100%;
}
.receive_execution_box > div:nth-last-child(1) {
  border-bottom: none;
}
.box_title {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  color: #272727;
  background-color: #f6f7fb;
  height: 43px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.box_inp_wrap {
  display: flex;
  gap: 8px;
  padding: 10px;
  justify-content: space-between;
  border-top: 1px solid #dbdbdb;
  position: relative;
}
.inp_text {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
  width: 200px;
}
.inp_rate {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
  width: 50px;
}
.inp_price {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
  width: 150px;
}
.box_inp_wrap > div {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
}
.pay_add_box {
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #dbdbdb;
  gap: 8px;
}
.pay_add_btn {
  border: 1px solid #dbdbdb;
  padding: 10px;
  border-radius: 4px;
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 12px;
  cursor: pointer;
}
.flex_wrap {
  gap: 4px;
  height: 39px;
}

.box_inp_wrap > .flex_wrap:nth-child(1) {
  width: 20%;
}
.box_inp_wrap > .flex_wrap:nth-child(2) {
  width: 30%;
}

.box_inp_wrap > .flex_wrap:nth-child(3) {
  width: 10%;
}

.box_inp_wrap > .flex_wrap:nth-child(4) {
  width: 40%;
  justify-content: flex-end;
}

.receive_execution_box > .box_inp_wrap > .flex_wrap:nth-child(1) {
  width: 15%;
}
.receive_execution_box > .box_inp_wrap > .flex_wrap:nth-child(2) {
  width: 20%;
}

.receive_execution_box > .box_inp_wrap > .flex_wrap:nth-child(3) {
  width: 10%;
}

.receive_execution_box > .box_inp_wrap > .flex_wrap:nth-child(4) {
  width: 30%;
  justify-content: flex-end;
}
.receive_execution_box > .box_inp_wrap > .flex_wrap:nth-child(5) {
  width: 25%;
  justify-content: flex-end;
}
.pay_gubun {
  font-family: "Noto Sans CJK KR-Medium";
  text-align: center;
}
.pay_date {
  font-family: "Noto Sans CJK KR-Medium";
  text-align: center;
}
.pay_rate {
  font-family: "Noto Sans CJK KR-Medium";
  text-align: right;
}
.pay_amt {
  font-family: "Noto Sans CJK KR-Medium";
  text-align: right;
}
.pay_mod_btn {
  position: absolute;
  right: 20px;
}
</style>
